"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._exportReportProdStatistic = exports._getReportProdStatistic = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("utils/constants");
const error_response_1 = require("utils/error-response");
const getFromLocalStorage = {
    token: () => {
        const token = localStorage.getItem(constants_1.localStorageKey.token);
        if (token)
            return token;
        return '';
    }
};
const _getReportProdStatistic = ({ skip, take, filter, sort }, start_date, end_date) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/report/prod-statistic';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString, start_date, end_date },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getReportProdStatistic = _getReportProdStatistic;
const _exportReportProdStatistic = ({ skip, take, filter, sort }, start_date, end_date, type) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/report/prod-statistic-export';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString, type, start_date, end_date },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, content: '', name: '', type: '', data: {} };
    }
});
exports._exportReportProdStatistic = _exportReportProdStatistic;
